import React from "react";
import { twMerge } from "tailwind-merge";

export interface PillProps extends React.HTMLProps<HTMLDivElement> {
  type: "primary";
  className?: string;
  bgColorClass?: string;
  textColorClass?: string;
}

const Pill: React.FunctionComponent<React.PropsWithChildren<PillProps>> = ({
  type = "primary",
  children,
  className = "",
  ...rest
}) => {
  const generatedPillTypes = {
    primary: "bg-indigo-100 p-1.5 text-indigo-500 rounded",
  };

  return (
    <span
      className={twMerge(
        `pill text-sm mr-1.5 mb-1.5`,
        generatedPillTypes[type],
        className
      )}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(rest as any)}
    >
      <span className={twMerge("flex-1 truncate")}>{children}</span>
    </span>
  );
};

export default Pill;
